module.exports = __webpack_public_path__ + "static/img/kjhf_add.6d3c0da.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/kjhf_add.jpeg
// module id = 1233
// module chunks = 0